import { chunk, cloneDeep, unionWith } from 'lodash-es';
import { getYearMonthDate, visibleDays, weekDays, isGte } from "../calendar";
import { convToDateFromYearMonthDate01 } from '../util/date';

/*

 [{
    date, serviceTime, customerId, customerName, deliveryGroup, 
    menu: date, serviceTime, published, menuType, supplierId, menuId, 
      supplier, menu, subMenu, ... 
 }]

 */

export function handleScheduleResult(data) {

  const meals = [];

  data.forEach(o => {

    let found = meals.find(m => 
      m.date === o.date && m.serviceTime === o.serviceTime);

    if (!found) {
      found = {
        date: o.date,
        serviceTime: o.serviceTime,
        customerId: o.customerId,
        customerName: o.customer?.name ?? null,
        // deliveryGroup: o.customer?.deliveryGroup?.desc ?? null,
        menu: []
      };
      meals.push(found);
    }

    found.menu.push(o);
  });

  return meals;
}

export function handleSuggestionResult(data) {

  const meals = [];

  data.forEach(dayOrders => {

    // NOTE: date (format 다름)
    const date = getYearMonthDate(dayOrders.date);

    dayOrders.menu.forEach(menu => {

      let found = meals.find(m => 
        m.date === date && m.serviceTime === menu.serviceTime);
  
      if (!found) {
        found = {
          date,
          serviceTime: menu.serviceTime,
          customerId: dayOrders.customerId,
          customerName: dayOrders.customerName,
          // deliveryGroup: dayOrders.deliveryGroup ?? null,
          menu: []
        };
        meals.push(found);
      }

      found.menu.push({
        published: false,
        date,
        serviceTime: menu.serviceTime,
        menuType: menu.menuType,
        menuId: menu.menuId,
        menu: {
          id: menu.menuId,
          name: menu.menuName,
          menuCategory: menu.menuCategory ?? []
        },
        supplierId: menu.supplierId,
        supplier: {
          id: menu.supplierId,
          name: menu.supplierName,
          serviceType: menu.serviceType ?? []
        },
        subMenu: menu.subMenu ?? [],
        pickupTime: menu.pickupTime,
        orderQty: null,
        memo: null
        // ... 
      });
    });
    
  });

  return meals;
}

export function getSortedMealsForDay(day, meals) {

  if (!meals || meals.length == 0) return [];

  // ex) 20201130 
  const dayString = getYearMonthDate(day);

  // 조중석 service time 추가할 수 있도록 placeholder 용도의 빈 meals 추가 
  const emptyMeals = [ "0", "1", "2" ].map(serviceTime => ({
    date: dayString,
    serviceTime,
    menu: []
  }));

  const sorted = 
    unionWith(
      meals.filter(m => m.date === dayString),
      emptyMeals, 
      (a, b) => (a.serviceTime === b.serviceTime))
    .sort((a, b) => {
      // sort by service time 
      if (a.serviceTime === b.serviceTime) {
        return 0;
      }
      return a.serviceTime < b.serviceTime ? -1 : 1;    
    });
    
  // sort menus by type 
  // menu sorting 은 리듀서에서 일괄 
  /* sorted.forEach(el => {
    el.menu.sort((a, b) => {
      if (a.menuType === b.menuType) {
        return 0;
      }
      return a.menuType < b.menuType ? -1 : 1;
    });
  }); */

  return sorted;
}

export function presentServiceTime(serviceTime) {
  let text;
  switch(serviceTime) {
  case "0":
    text = '아침';
    break;
  case "1": 
    text = '점심';
    break;
  case "2":
    text = '저녁';
    break;
  default:
    text = '기타';
  }
  return text;
}

export const WeekDayKeys = [
  'serviceMon', 'serviceTue', 'serviceWed',
  'serviceThu', 'serviceFri', 'serviceSat', 'serviceSun'
];

export const WeekDayKeysKor = [
  '월', '화', '수', '목', '금', '토', '일'
];

const EmptyMenu = {
  45: {
    
  },
  46: {

  },
  47: {

  }
};

/**
 * customer.serviceTime 기반으로 placeholder 생성 
 * @param {*} serviceTime 
 */
export function getServiceInfo(serviceTime, firstDate) {
  const datesOfMonth = visibleDays(firstDate);
  const weeks = chunk(datesOfMonth, 7);
  const meals = [];
  weeks.forEach(week => {
    week.map((day, i) => {
      const date = getYearMonthDate(day);
      serviceTime.forEach(s => {
        if (s[WeekDayKeys[i]]) {  // 해당 요일에 서비스 제공 여부 
          // placeholder 추가 
          let found = meals.find(
            m => m.serviceTime === s.serviceTime && m.date === date);
          if (!found) {
            found = {
              date,
              serviceTime: s.serviceTime,
              services: []
            };
            meals.push(found);
          }
          s.serviceType.forEach(st => { found.services.push(st); });
        }
      });
    });
  });

  return meals;
}

const WeekDayKeys2 = [
  'serviceSun', 'serviceMon', 'serviceTue', 'serviceWed',
  'serviceThu', 'serviceFri', 'serviceSat'
]

export const getDayKey = (day) => {
  return WeekDayKeys2[day.getDay()];
}

/**
 * 
 * @param {*} serviceTimes customer serviceTimes 
 * @param {*} dateString YYYYMMDD
 * @param {*} serviceTime '0' | '1' | '2' 
 * @returns 
 */
export const findServiceTime = (serviceTimes, dateString, serviceTime) => {
  const date = convToDateFromYearMonthDate01(dateString);
  const dayKey = WeekDayKeys2[date.getDay()];
  return serviceTimes.find(el => 
    el.serviceTime === serviceTime && !!el[dayKey]);
}

export const findSiblingServiceTime = (serviceTimes, serviceTime) => {
  return serviceTimes.find(el => el.serviceTime === serviceTime);
}

/**
 * delivery service 개발 전까지 사용 
 * @param {*} timeString HHMM
 */
export const computePickupTime = (timeString) => {
  // regex checking 

  const pickupLeadTime = 40; // in minutes 
  const hours = parseInt(timeString.substring(0, 2));
  const mins = parseInt(timeString.substring(2, 4));
  const pickupTimes = hours * 60 + mins - pickupLeadTime;
  return (pickupTimes/60>>0).toString().padStart(2, '0')
    + (pickupTimes%60).toString().padStart(2, '0');
}

export function hasDefaultMenu(menuList) {
  return menuList.length > 0 &&
    menuList.some(menu => menu.menuType === '0');
}

export function isPbMenu(menu) {
  if (menu.supplier) {
    return menu.supplier.serviceType.some(el => el.id === 47);
  }
  else if (menu.menuType !== '2') {
    return menu.serviceType === 'pb';
  }
  else {
    return false;
  }
}

export function sortMenus(menuList) {
  // sort by service type 
  menuList.sort((a, b) => {
    if (isPbMenu(a)) {
      return 1;
    }
    else if (isPbMenu(b)) {
      return -1;
    }
    else {
      return a.menuType < b.menuType ? -1 : 1;
    }
  });
}

export function computeMenuRatio(defaultRatio, meals) {
  // ratioData 
  let total = 0, 
      counts = {};
  defaultRatio.forEach(r => counts[r.menuCategoryId] = 0);

  // count menus 
  const catIdKey = 'categoryLv1Id';
  meals.forEach(meal => {
    meal.menu.forEach(menu => {
      if (menu.menu?.menuCategory && menu.menu.menuCategory.length > 0) {
        const cat = menu.menu.menuCategory.find(mc => mc.hasOwnProperty(catIdKey));
        if (cat) {
          counts[cat[catIdKey]] += 1;
          total++;
        }
      }
    })
  });

  // compute & return 
  return defaultRatio.map(r => {
    if (total <= 0) return r;

    const newRatio = cloneDeep(r);
    const count = counts[r.menuCategoryId];
    newRatio.ratio = ((count / total) * 100).toFixed();
    return newRatio;
  });
}

/**
 * 배포 api 의 '주' 기준을 제공. 
 * 추후에는 없어진다. 
 * @param {*} week 
 * @returns 
 */
export function getApiWeekdays(week) {
  const monday = week.find(d => d.getDay() === 1);
  let dates = weekDays(monday, 1);
  return dates;
}

/**
 * 해당 week가 published 여부는 두 가지 로직을 선택해서 적용 
 * a) 모든 메뉴가 published 경우 
 * b) 한 개 메뉴라도 published 경우 (배포된 메뉴들의 시점은 동일해야 함)
 * @param {*} dates 배포 여부 판단한 dates 
 * @param {*} meals 현재 메뉴 스케줄 데이터 
 * @param {*} logic 'a' / 'b' 
 * @returns 
 */
export function isAllPublished(dates, meals, logic = 'a') {
  const daysPublished = [];
  dates.forEach(d => {
    const dateString = getYearMonthDate(d);
    const dayMeals = meals.filter(meal => 
      meal.date === dateString && 
      meal.menu.filter(menu => menu.menuId !== null || menu.menuType === '2').length > 0);

    // 판별 정보 없는 day 는 이 시점에선 무시 
    if (dayMeals.length === 0) return ;

    // check if a day is published or not 
    const published = logic === 'a' ?
      dayMeals.every(meal => meal.menu.some(menu => menu.published)) : 
      dayMeals.some(meal => meal.menu.some(menu => menu.published));
    daysPublished.push(published);
  });
  // console.log(dates.map(d => getYearMonthDate(d)).join() + ' > ' + JSON.stringify(daysPublished))
  return logic === 'a' ?
    daysPublished.length > 0 && daysPublished.every(published => published) :
    daysPublished.length > 0 && daysPublished.some(published => published);
}

export function presentPricingModel(pricingModel) {
  switch(pricingModel) {
  case 'tiered':
    return '계약단가';
  case 'product-based':
    return '판매가';
  default:
    return '미지정(계약단가)';
  }
}

export function presentServiceType(serviceType) {
  if (serviceType === 45) {
    return '밀박스';
  }
  else if (serviceType === 46) {
    return '뷔페';
  }
  else if (serviceType === 47) {
    return 'PB샐러드';
  }
  else {
    return '기타';
  }
}

export const getPlans = (serviceTimes, menu) => {
  if (!menu) {
    return [];
  }

  const plans = [];
  serviceTimes
    .filter(st => st.serviceTime === menu.serviceTime)
    .filter(st => {
      const dayKey = getDayKey(convToDateFromYearMonthDate01(menu.date));
      return st[dayKey];
    })
    .forEach(st => {
      st.servicePlan
        // Note: 현시점 mealbox 만 지원 
        .filter(sp => 
            // sp.serviceTypeId === 45 && sp.pricingModel === 'tiered' && sp.tierPrice
            sp.serviceTypeId === 45 || sp.serviceTypeId === 46
          )
        .forEach(sp => {
          plans.push(
            Object.assign({}, sp, {
              isDefault: st.defaultPlan?.id === sp.id
            })
          );
        });
    });

  plans.sort((a, b) => {
    if (a.pricingModel === 'tiered' && b.pricingModel !== 'tiered') {
      return -1;
    }
    if (a.pricingModel !== 'tiered' && b.pricingModel === 'tiered') {
      return 1;
    }
    /* if (a.isDefault && !b.isDefault) {
      return -1;
    }
    if (!a.isDefault && b.isDefault) {
      return 1;
    } */
    if (a.tierPrice === b.tierPrice) {
      return 0;
    }
    return a.tierPrice < b.tierPrice ? -1 : 1;
  });

  return plans;
}

export const getParentServiceTime = (serviceTimes, plan) => {
  for (const st of serviceTimes) {
    const found = st.servicePlan.find(sp => sp.id === plan.id);
    if (found) {
      return st;
    }
  }
  return null;
}